import { render, staticRenderFns } from "./ResultsFirstPurchaseCard.vue?vue&type=template&id=28caeec9"
import script from "./ResultsFirstPurchaseCard.vue?vue&type=script&lang=js"
export * from "./ResultsFirstPurchaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports